import { render, staticRenderFns } from "./AsterSms.vue?vue&type=template&id=01fae405&"
import script from "./AsterSms.vue?vue&type=script&lang=js&"
export * from "./AsterSms.vue?vue&type=script&lang=js&"
import style0 from "./AsterSms.vue?vue&type=style&index=0&id=01fae405&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports